import './MappingsEditor.scss';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Form, Table } from "react-bootstrap";
import IconButton from "../common/IconButton";
import { TuningPropertyMapping } from '../../models/BdaService';

type Props = {
  mappings: TuningPropertyMapping[];
  onMappingsChange: (value: TuningPropertyMapping[]) => void;
}

export const MappingsEditor = ({ mappings, onMappingsChange }: Props) => {
  const [newMapping, setNewMapping] = useState<TuningPropertyMapping>({ name: '', intValue: '' });

  const handleFieldChange = (field: keyof TuningPropertyMapping) => (evt: React.ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.value;

    setNewMapping({
      ...newMapping,
      [field]: value,
    });
  }

  const removeMapping = (index: number) => () => {
    const newMappings = [...mappings];
    newMappings.splice(index, 1);
    onMappingsChange(newMappings);
  }

  const submitMapping = () => {
    if (newMapping.name === '' || newMapping.intValue === '') return;
    onMappingsChange(mappings.concat(newMapping));
    setNewMapping({ name: '', intValue: '' });
  }

  return (
    <Table className="mappings-editor" bordered>
      <thead>
        <tr>
          <th>Name</th>
          <th>Integer Value</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td className="input">
            <Form.Control value={newMapping.name} onChange={handleFieldChange('name')} size="sm" placeholder="Mapping name" />
          </td>
          <td className="input">
            <Form.Control
              type="number"
              value={newMapping.intValue}
              onChange={handleFieldChange('intValue')}
              size="sm"
              placeholder="Mapping integer value"
            />
          </td>
          <td>
            <IconButton type="button" className="text-success" onClick={submitMapping} tooltip="Confirm">
              <FontAwesomeIcon icon={solid('check')} />
            </IconButton>
          </td>
        </tr>

        {mappings?.map((mapping, index) => (
          <tr key={mapping.name}>
            <td>{mapping.name}</td>
            <td>{mapping.intValue}</td>
            <td>
              <IconButton type="button" onClick={removeMapping(index)}>
                <FontAwesomeIcon icon={solid('times')} />
              </IconButton>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}